<app-modal-wrapper [staticHeight]="staticHeight" [modal]="modal">
  <ng-container>
    <div class="restrict-account-content">
      <!-- Первичное описание (до выполнения операции) -->
      <div class="modal-header" *ngIf="!isCompleted">
        <p class="header-title">
          Полное ограничение для счета<br />
          {{ formattedAccountNumber }}
        </p>
      </div>

      <div class="warning-message" *ngIf="!isCompleted">
        <ion-icon name="alert-circle-outline" class="warning-icon" color="danger" slot="start"></ion-icon>
        <p class="warning-text">
          Внимание! После применения ограничения счет будет скрыт из личного кабинета, и все операции с ним будут
          доступны только в офисе банка.
        </p>
      </div>

      <!-- Сообщение об успешном ограничении -->
      <div class="success" *ngIf="isCompleted && isSuccess">
        <p class="result-text success-text">
          <span class="red-message">
            Счет {{ formattedAccountNumber }}<br />
            от {{ formattedOpenDate }} ограничен
          </span>
        </p>
      </div>

      <!-- Сообщение об ошибке -->
      <div class="result-message error" *ngIf="isCompleted && !isSuccess">
        <ion-icon name="close-circle-outline" class="result-icon error"></ion-icon>
        <p class="result-text error">{{ errorText }}</p>
      </div>
    </div>
  </ng-container>

  <ion-footer class="ion-no-border" footer *ngIf="!isCompleted">
    <ion-button class="button block danger-button shadow" mode="ios" expand="block" (click)="restrictAccount()">
      Ограничить счет
    </ion-button>
  </ion-footer>

  <ion-footer class="ion-no-border" footer *ngIf="isCompleted">
    <ion-button class="button block primary shadow" mode="ios" expand="block" (click)="goToMain()">
      На главный экран
    </ion-button>
  </ion-footer>
</app-modal-wrapper>
